module.exports = __webpack_public_path__ + "static/media/payrollnew.8bf74030.svg";